import * as React from 'react';
export const publicSvg = React.forwardRef(function publicSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#CF2A2C',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M25 9.677 19.81 4.5h-7.536L7 9.762v5.432l.837.763-.837.764v5.431l5.19 5.177h7.703L25 22.238v-5.602l-.754-.679.754-.679v-5.6Zm-8.958 16.04-6.196-6.28.67-.68 1.675 1.613h7.702l1.674-1.697.754.764-6.28 6.28Zm-2.763-9.76 2.763-2.8 2.846 2.8-2.846 2.8-2.763-2.8Zm8.288-2.8-1.758-1.698h-7.535l-1.758 1.782-.67-.763 6.196-6.28 6.279 6.28-.754.679Z',
      fill: '#fff',
    }),
  );
});
publicSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var publicIcon = {
  category: 'brand',
  colorable: false,
  name: 'public',
  svg: publicSvg,
};
